export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      total: 0,
      currentPage: 1,
      limit: 20,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 表格数据
      signVoucherGenerationList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      open1: false,
      // 查询参数
      queryParams: {
        maindjh: undefined,
        billcode: undefined
      },
      // 表单参数
      form: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {

    getList() {
      this.loading = true
      const data = {
        currentPage: this.currentPage,
        limit: this.limit,
        maindjh: this.queryParams.maindjh,
        billNo: this.queryParams.billcode
      }
      this.$post('/fesback/Financial/voucherGenerationList.z', data).then(request => {
        this.signVoucherGenerationList = request.data.data
        this.total = request.data.count
        this.loading = false
        this.$message({
          message: request.message,
          type: 'success'
        })
      })
    },
    handleQuery() {
      this.currentPage = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleSizeChange(val) { // 每页多少条
      this.limit = val
      this.getList()
    },
    handleCurrentChange(val) { // 当前页
      this.currentPage = val
      this.getList()
    }
  }
}
